<template>
  <header id="header" class="header">
    <div class="header-section">
      <div id="logoAndNav" class="container">
        <!-- Nav -->
        <nav class="js-mega-menu navbar navbar-expand-lg">
          <!-- Logo -->
          <a
            class="navbar-brand"
            href="/"
            aria-label="Front"
          >
            <img src="@/assets/svg/logos/logo.svg" alt="Logo" />
          </a>
          <!-- End Logo -->

          <!-- Responsive Toggle Button -->
          <button
            type="button"
            class="navbar-toggler btn btn-icon btn-sm rounded-circle"
            aria-label="Toggle navigation"
            aria-expanded="false"
            aria-controls="navBar"
            data-toggle="collapse"
            data-target="#navBar"
          >
            <span class="navbar-toggler-default">
              <svg
                width="14"
                height="14"
                viewBox="0 0 18 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M17.4,6.2H0.6C0.3,6.2,0,5.9,0,5.5V4.1c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,5.9,17.7,6.2,17.4,6.2z M17.4,14.1H0.6c-0.3,0-0.6-0.3-0.6-0.7V12c0-0.4,0.3-0.7,0.6-0.7h16.9c0.3,0,0.6,0.3,0.6,0.7v1.4C18,13.7,17.7,14.1,17.4,14.1z"
                />
              </svg>
            </span>
            <span class="navbar-toggler-toggled">
              <svg
                width="14"
                height="14"
                viewBox="0 0 18 18"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill="currentColor"
                  d="M11.5,9.5l5-5c0.2-0.2,0.2-0.6-0.1-0.9l-1-1c-0.3-0.3-0.7-0.3-0.9-0.1l-5,5l-5-5C4.3,2.3,3.9,2.4,3.6,2.6l-1,1 C2.4,3.9,2.3,4.3,2.5,4.5l5,5l-5,5c-0.2,0.2-0.2,0.6,0.1,0.9l1,1c0.3,0.3,0.7,0.3,0.9,0.1l5-5l5,5c0.2,0.2,0.6,0.2,0.9-0.1l1-1 c0.3-0.3,0.3-0.7,0.1-0.9L11.5,9.5z"
                />
              </svg>
            </span>
          </button>
          <!-- End Responsive Toggle Button -->

          <!-- Navigation -->
          <div id="navBar" class="collapse navbar-collapse">
            <div class="navbar-body header-abs-top-inner">
              <ul class="navbar-nav">
                <!-- 关于我们 -->
                <li class="hs-has-sub-menu navbar-nav-item">
                  <a
                    id="blogMegaMenu"
                    class="hs-mega-menu-invoker nav-link nav-link-toggle"
                    href="#"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-labelledby="blogSubMenu"
                    >公司介绍</a
                  >

                  <!-- Blog - 关于我们 -->
                  <div
                    id="blogSubMenu"
                    class="hs-sub-menu dropdown-menu"
                    aria-labelledby="blogMegaMenu"
                    style="min-width: 230px"
                  >
                    <router-link class="dropdown-item" :to="{ path: '/introduction' }"
                      >企业简介</router-link
                    >
                    <router-link
                      class="dropdown-item"
                      :to="{ path: '/history' }"
                      >发展历程</router-link
                    >
                    <router-link
                      class="dropdown-item"
                      :to="{ path: '/culture' }"
                      >企业文化</router-link
                    >

                    <div class="dropdown-divider"></div>
                    <router-link
                      class="dropdown-item"
                      :to="{ path: '/download' }"
                      >下载画册</router-link
                    >
                  </div>
                  <!-- End 关于我们 -->
                </li>
                <!-- End 关于我们 -->

                <!-- 产品展示 -->
                <li class="hs-has-sub-menu navbar-nav-item">
                  <a
                    id="blogMegaMenu"
                    class="hs-mega-menu-invoker nav-link nav-link-toggle"
                    href="javascript:;"
                    aria-haspopup="true"
                    aria-expanded="false"
                    aria-labelledby="blogSubMenu"
                    >产品展示</a
                  >

                  <!-- Blog - Submenu -->
                  <div
                    id="blogSubMenu"
                    class="hs-sub-menu dropdown-menu"
                    aria-labelledby="blogMegaMenu"
                    style="min-width: 230px"
                  >
                    <router-link class="dropdown-item" :to="{ path: '/devs' }"
                      >万物云CMS</router-link
                    >
                    <li class="dropdown-item" style="cursor:pointer" @click="goWy(1)"
                      >简居圈</li
                    >
                    <li class="dropdown-item" style="cursor:pointer" @click="goWy(2)"
                      >X-DaTa</li
                    >
                  </div>
                  <!-- End Submenu -->
                </li>
                <!-- End 产品展示 -->

                <!-- 合作生态 -->
                <li
                  class="hs-has-mega-menu navbar-nav-item"
                  data-hs-mega-menu-item-options='{
         "desktop": {
           "position": "right",
           "maxWidth": "900px"
         }
       }'
                >
                  <a
                    id="demosMegaMenu"
                    class="hs-mega-menu-invoker nav-link nav-link-toggle"
                    href="javascript:;"
                    aria-haspopup="true"
                    aria-expanded="false"
                    >行业方案</a
                  >

                  <!-- Demos - Mega Menu -->
                  <div
                    class="hs-mega-menu dropdown-menu w-100"
                    aria-labelledby="demosMegaMenu"
                    
                  >
                    <div class="row no-gutters">
                      <!-- Promo -->
                      <div class="col-lg-4 navbar-promo d-none d-lg-block" style="height:320px">
                        <router-link
                          class="d-block navbar-promo-inner"
                          :to="{ path: '/plan',query:{columnId:hyleft.columnId} }"
                        >
                          <div class="position-relative">
                            <img
                              class="img-fluid rounded mb-3"
                              :src="getImgUrl(hyleft.image)"
                              alt="Image Description"
                            />
                          </div>
                          <span class="navbar-promo-title font-size-2"
                            >{{hyleft.title}}</span
                          >
                          <span class="navbar-promo-text"
                            >{{hyleft.subtitle}}</span
                          >
                        </router-link>
                      </div>
                      <!-- End Promo -->

                      <div class="col-lg-8">
                        <div class="navbar-promo-card-deck">
                          <!-- Promo Item -->
                          <div style="cursor:pointer" v-for="item in hylist.one" :key="item.columnId" class="navbar-promo-card navbar-promo-item">
                              <a class="navbar-promo-link">
                                <div class="media align-items-center" @click="skip(item.columnId)">
                                    <img class="navbar-promo-icon" :src="getImgUrl(item.image)" alt="SVG"/>
                                    <div class="media-body">
                                      <span class="navbar-promo-title">{{item.title}}</span>
                                      <span class="navbar-promo-text">{{item.subtitle}}</span>
                                      <span class="navbar-promo-text">More reading...</span>
                                    </div>
                                </div>
                              </a>
                          </div>
                          <!-- End Promo Item -->
                        </div>
                        <div class="navbar-promo-card-deck">
                          <!-- Promo Item -->
                          <div style="cursor:pointer" v-for="item in hylist.two" :key="item.columnId" class="navbar-promo-card navbar-promo-item">
                              <a class="navbar-promo-link">
                                <div class="media align-items-center" @click="skip(item.columnId)">
                                    <img class="navbar-promo-icon" :src="getImgUrl(item.image)" alt="SVG"/>
                                    <div class="media-body">
                                      <span class="navbar-promo-title">{{item.title}}</span>
                                      <span class="navbar-promo-text">{{item.subtitle}}</span>
                                      <span class="navbar-promo-text">More reading...</span>
                                    </div>
                                </div>
                              </a>
                          </div>
                          <!-- End Promo Item -->
                        </div>
                        <div class="navbar-promo-card-deck">
               
                          <!-- Promo Item -->
                          <div style="cursor:pointer" v-for="item in hylist.three" :key="item.columnId" class="navbar-promo-card navbar-promo-item">
                              <a class="navbar-promo-link">
                                <div class="media align-items-center" @click="skip(item.columnId)">
                                    <img class="navbar-promo-icon" :src="getImgUrl(item.image)" alt="SVG"/>
                                    <div class="media-body">
                                      <span class="navbar-promo-title">{{item.title}}</span>
                                      <span class="navbar-promo-text">{{item.subtitle}}</span>
                                      <span class="navbar-promo-text">More reading...</span>
                                    </div>
                                </div>
                              </a>
                          </div>
                          <div v-if="hylist.three && hylist.three.length == 1"  class="navbar-promo-card navbar-promo-item">
                              
                          </div>
                          <!-- End Promo Item -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- End Demos - Mega Menu -->
                </li>
                <!-- End 合作生态 -->

                <!-- 客户案例 -->
                <li>
                  <router-link
                    class="hs-mega-menu-invoker nav-link addhover"
                    :to="{ path: '/case' }"
                    >客户案例</router-link
                  >
                </li>
                <!-- End 客户案例 -->

                <!-- 公告动态 -->
                <li>
                  <router-link
                    class="hs-mega-menu-invoker nav-link addhover"
                    to="/articleList"
                    >新闻公告</router-link
                  >
                </li>
                <!-- End 公告动态 -->

                <!-- 帮助中心 -->
                <li
                  class="hs-has-mega-menu navbar-nav-item"
                  data-hs-mega-menu-item-options='{
                       "desktop": {
                         "position": "right",
                         "maxWidth": "260px"
                       }
                     }'
                >
                  <a
                    id="docsMegaMenu"
                    class="hs-mega-menu-invoker nav-link nav-link-toggle"
                    href="javascript:;"
                    aria-haspopup="true"
                    aria-expanded="false"
                    >帮助中心</a
                  >

                  <!-- Docs - Submenu -->
                  <div
                    class="hs-mega-menu dropdown-menu"
                    aria-labelledby="docsMegaMenu"
                    style="min-width: 332px"
                  >
                    <!-- Promo Item -->
                    <div class="navbar-promo-item">
                      <a
                        class="navbar-promo-link"
                        href="http://devs.cltc.info/"
                        target="_blank"
                      >
                        <div class="media align-items-center">
                          <img
                            class="navbar-promo-icon"
                            src="@/assets/svg/icons/icon-2.svg"
                            alt="SVG"
                          />
                          <div class="media-body">
                            <span class="navbar-promo-title">
                              DEVS操作手册
                              <span class="badge badge-primary badge-pill ml-1"
                                >v2.0</span
                              >
                            </span>
                            <small class="navbar-promo-text"
                              >帮助用户快速使用并掌握</small
                            >
                          </div>
                        </div>
                      </a>
                    </div>
                    <div class="navbar-promo-item">
                      <a
                        class="navbar-promo-link"
                        href="http://cms.cltc.info/"
                        target="_blank"
                      >
                        <div class="media align-items-center">
                          <img
                            class="navbar-promo-icon"
                            src="@/assets/svg/icons/icon-2.svg"
                            alt="SVG"
                          />
                          <div class="media-body">
                            <span class="navbar-promo-title">
                              CMS 操作手册
                              <span class="badge badge-primary badge-pill ml-1"
                                >v1.9</span
                              >
                            </span>
                            <small class="navbar-promo-text"
                              >功能强大的全新网站系统</small
                            >
                          </div>
                        </div>
                      </a>
                    </div>
                    <!-- End Promo Item -->

                    <div class="navbar-promo-footer">
                      <!-- List -->
                      <div class="row no-gutters">
                        <div class="col-6">
                          <div class="navbar-promo-footer-item">
                            <span class="navbar-promo-footer-text"
                              >DEVS产品更新日志</span
                            >
                            <router-link class="navbar-promo-footer-text"  :to="{path: '/newup'}">最新更新</router-link>

                          </div>
                        </div>
                        <div class="col-6 navbar-promo-footer-ver-divider">
                          <div class="navbar-promo-footer-item">
                            <span class="navbar-promo-footer-text"
                              >CMS产品更新日志</span
                            >
                            <router-link class="navbar-promo-footer-text"  :to="{path: '/newupCms'}">最新更新</router-link>
                          </div>
                        </div>
                      </div>
                      <!-- End List -->
                    </div>
                  </div>
                  <!-- End Docs - Submenu -->
                </li>
                <!-- End 帮助中心 -->
               <!-- 公司产品地址管理 -->
                <!-- <li>
                  <router-link
                    class="hs-mega-menu-invoker nav-link addhover"
                    :to="{ path: '/softwareList' }"
                    >公司产品</router-link
                  >
                </li> -->
                <!-- End 公司产品地址管理 -->
                <!-- 联系我们 -->
                <li class="navbar-nav-last-item">
                  <router-link class="btn btn-sm btn-primary transition-3d-hover" target="_blank" :to="{path: '/contact'}">联系我们</router-link>
                </li>
                <!-- End 联系我们 -->
              </ul>
            </div>
          </div>
          <!-- End Navigation -->
        </nav>
        <!-- End Nav -->
      </div>
    </div>
  </header>
</template>
<script>
import "@/assets/vendor/jquery/dist/jquery.min.js";
import "@/assets/vendor/jquery-migrate/dist/jquery-migrate.min.js";

import "@/assets/vendor/font-awesome/css/all.min.css";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.css";
import "@/assets/css/theme.css";
import "@/assets/vendor/hs-header/dist/hs-header.min.js";
import "@/assets/vendor/hs-go-to/dist/hs-go-to.min.js";
import "@/assets/vendor/hs-unfold/dist/hs-unfold.min.js";
import "@/assets/vendor/hs-mega-menu/dist/hs-mega-menu.min.js";
import "@/assets/vendor/hs-show-animation/dist/hs-show-animation.min.js"; //8.
import "@/assets/vendor/jquery-validation/dist/jquery.validate.min.js"; //9.

import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "@/assets/js/hs.core.js";
import "@/assets/js/hs.validation.js"; // 11.
import {getsycolumn} from '../request/index'
export default {
  data(){
    return{
      hylist:{
        one:[],
        two:[],
        three:[],
      },
      hyleft:{}
    }
  },
  created(){
    this.getHY()
  },
  methods:{
    getHY(){
      getsycolumn(0).then(res=>{
        let arr = res.data
        arr.forEach(item=>{
          if(item.title == "行业方案"){
            getsycolumn(item.columnId).then(res=>{
              let arr1 = res.data
              arr1.forEach(hs=>{
                if(hs.type == "left"){this.hyleft = hs;}else{
                  if(this.hylist.one.length != 2){
                    this.hylist.one.push(hs)
                  }else{
                    if(this.hylist.two.length != 2 ){this.hylist.two.push(hs)}else{
                      if(this.hylist.three.length != 2){
                          this.hylist.three.push(hs)
                          if(this.hylist.three.length == 2){
                              this.hylist.three = this.hylist.three.sort((a,b)=>{return a.type - b.type})
                          }
                        }
                    }
                  }
                }
              })
            })
          }
        })
      })
    },
    getImgUrl(id){
      return process.env.NODE_URL + "api/files/getFileStream?fileId="+id
    },
    skip(id){
      this.$router.push({path:'/plan',query:{columnId:id}})
    },
    goWy(type){
        if(type == 1)window.open('https://wy.mssxapp.com')
        if(type == 2)window.open('http://8.131.238.238:9080/index')
    }
  },
  mounted(){
    var _hmt = _hmt || [];
    (function() {
      var hm = document.createElement("script");
      hm.src = "//hm.baidu.com/hm.js?1b71404ea88d54cae0211e184cb2ca4a";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
    })();
  }
};
</script>
<style scoped>
.navbar {
  padding: 0 !important;
}
a {
  text-decoration: none;
}
.navbar-promo-title {
  width: 193px;
}
.font-size-2 {
  font-size: 1.3rem;
}
.addhover:hover{
  color: #007bff;
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue